<div>
    <hub-modal-header headerText="{{ 'bikeshop.workshop.jobcard.timer_audit_trail' | translate }}"
        [activeModal]="activeModal"></hub-modal-header>
</div>

<div class="modal-content-container">
    <!-- Loading State -->
    <div *ngIf="loading" class="loading-container">
        <daz-icon [name]="'spinner'" [spin]="true" [size]="'32px'" [color]="'#EE3158'"></daz-icon>
        <p>{{ 'bikeshop.workshop.jobcard.loading_timer_logs' | translate }}</p>
    </div>

    <!-- No Logs State -->
    <div *ngIf="!loading && timerLogs.length === 0" class="no-logs-container">
        <daz-icon [name]="'clock'" [size]="'48px'" [color]="'#CCCCCC'"></daz-icon>
        <p>{{ 'bikeshop.workshop.jobcard.no_timer_logs' | translate }}</p>
    </div>

    <!-- Timer Logs List -->
    <div *ngIf="!loading && timerLogs.length > 0" class="timer-logs-container">
        <!-- Summary Header -->
        <div class="logs-summary">
            <div class="summary-item">
                <span class="summary-label">{{ 'bikeshop.workshop.jobcard.total_sessions' | translate }}:</span>
                <span class="summary-value">{{timerLogs.length}}</span>
            </div>
            <div class="summary-item">
                <span class="summary-label">{{ 'bikeshop.workshop.jobcard.total_duration' | translate }}:</span>
                <span class="summary-value">{{getTotalDuration()}}</span>
            </div>
        </div>

        <!-- Timer Log Items -->
        <div class="timer-log-item" *ngFor="let log of timerLogs; let i = index" [class.active]="isActiveTimer(log)">
            <div class="log-header">
                <div class="log-number">
                    <daz-icon [name]="isActiveTimer(log) ? 'clock' : 'clock-check'" 
                              [size]="'20px'" 
                              [color]="isActiveTimer(log) ? '#EE3158' : '#28a745'"></daz-icon>
                    <span>{{ 'bikeshop.workshop.jobcard.session' | translate }} #{{timerLogs.length - i}}</span>
                    <span *ngIf="isActiveTimer(log)" class="active-badge">{{ 'general.active' | translate }}</span>
                </div>
                <div class="log-duration">
                    <span class="duration-value">{{formatDuration(log.durationSeconds)}}</span>
                </div>
            </div>

            <div class="log-details">
                <div class="detail-row">
                    <div class="detail-item">
                        <daz-icon [name]="'clipboard-user'" [size]="'14px'" [color]="'#888888'"></daz-icon>
                        <span class="detail-label">{{ 'bikeshop.modal.add_edit_user.technician' | translate }}:</span>
                        <span class="detail-value">{{log.technicianName}}</span>
                    </div>
                    <div class="detail-item">
                        <daz-icon [name]="'user'" [size]="'14px'" [color]="'#888888'"></daz-icon>
                        <span class="detail-label">{{ 'bikeshop.workshop.jobcard.started_by' | translate }}:</span>
                        <span class="detail-value">{{log.timerStartedBy}}</span>
                    </div>
                </div>

                <div class="detail-row">
                    <div class="detail-item">
                        <daz-icon [name]="'play'" [size]="'14px'" [color]="'#888888'"></daz-icon>
                        <span class="detail-label">{{ 'bikeshop.workshop.jobcard.start_time' | translate }}:</span>
                        <span class="detail-value">{{formatDateTime(log.startTime)}}</span>
                    </div>
                    <div class="detail-item" *ngIf="!isActiveTimer(log)">
                        <daz-icon [name]="'stop'" [size]="'14px'" [color]="'#888888'"></daz-icon>
                        <span class="detail-label">{{ 'bikeshop.workshop.jobcard.end_time' | translate }}:</span>
                        <span class="detail-value">{{formatDateTime(log.endTime)}}</span>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
